export default [
  {
    title: 'مدیریت کمپین ها',
    icon: 'bx bx-chalkboard',
    children: [
      {
        title: 'کانال های تبلیغاتی',
        route: { name: 'channels' },
        resource: 'CampaignManager',
        action: 'show',
      },
      {
        title: 'کمپین های تبلیغاتی',
        route: { name: 'campaigns' },
        resource: 'CampaignManager',
        action: 'show',
      },
      {
        title: 'اتریبیوشن و ترکرها',
        route: { name: 'attributions' },
        resource: 'CampaignManager',
        action: 'show',
      },
      {
        title: 'بودجه تبلیغات',
        route: { name: 'charges' },
        resource: 'CampaignManager',
        action: 'show',
      },
      {
        title: 'گزارش متریکس',
        route: { name: 'metrixReport' },
        resource: 'CampaignManager',
        action: 'show',
      },
      {
        title: 'گزارش ادتریس',
        route: { name: 'adtraceReport' },
        resource: 'CampaignManager',
        action: 'show',
      },
      {
        title: 'گزارش ترکر',
        route: { name: 'trackerReport' },
        resource: 'CampaignManager',
        action: 'show',
      }
    ],
  },
]
